import React, { useEffect, useState } from "react";
import Direct from "../../assets/direct.png";
import Milap from "../../assets/milap.png";
import Ketto from "../../assets/ketto.svg";
import ImpactGuru from "../../assets/impactGuru.png";
import Loading from "../../assets/loading.gif";
import moment from "moment";

// Add commas in numbers, e.g. 123456 => 1,23,456
export const numberWithCommas = input => {
    try {
        let num = input;

        if (typeof num !== 'number') {
            if (typeof num === 'string' && num.trim()) {
                num = Number(num);
                if (isNaN(num)) {
                    return input;
                }
            } else {
                return input;
            }
        }

        return num.toLocaleString('en-IN');
    } catch (err) {
        return input;
    }
};

const Home = () => {

    const [loading, setLoading] = useState(false);

    const getData = async () => {

        setLoading(true);
        fetch("https://603a5909f1d6aa0017a107e1.mockapi.io/api/v1/Data/1", {
            method: "GET",
            headers: {
                "content-type": "Application/json"
            }
        }).then(res => {
            setLoading(false);
            if(res.status === 200){
                res.json()
                .then(data => {
                    setDirect(+data.direct);
                    setMilap(+data.milap);
                    setKetto(+data.ketto);
                    setImpactGuru(+data.impactGuru);
                    setUpdatedAt(data.updatedAt);
                    // setDirect(160000000);
                    // setMilap(160000000);
                    // setKetto(160000000);
                    // setImpactGuru(160000000);
                })
                .catch(err => console.log(err))
            }else{
                res.json()
                .then(data => {
                    
                })
                .catch(err => console.log(err))
            }
        }).catch(err => {
            setLoading(false);
            console.log(err);
        })
    };

    const [direct, setDirect] = useState(0);
    const [milap, setMilap] = useState(0);
    const [ketto, setKetto] = useState(0);
    const [impactGuru, setImpactGuru] = useState(0);
    const [updatedAt, setUpdatedAt] = useState(null); 

    useEffect(() => {
        getData();
    }, [])

    return(
        <div>
            {
                loading ?
                <div style={{ textAlign: 'center', height: "calc(100vh - 24rem)", display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img src={Loading} alt="loading" style={{ width: '100px' }} />
                </div>
                :
                <>
                    <h3 style={{ marginLeft: "2rem" }}>Bharathi's Fundraiser Dashboard</h3>

                    <div className="dashboard_wrapper">
                        <p className="dashboard_header">Total Amount Collected Via Campaigns</p>
                        {
                            updatedAt ?
                            <p className="dashboard_header2">Updated {moment(updatedAt).format("DD-MM-YYYY hh:mm A")}</p>
                            :
                            null
                        }

                        <div className="row" style={{ textAlign: "center" }}>
                            <div className="col-sm-12 col-md-4" >
                                <div className="dashboard_card">
                                    <p className="heading_text">
                                        Total Collected
                                    </p>

                                    <p className="first_card">
                                        #SaveBharathi
                                    </p>

                                    <p style={{ color: "green", fontWeight: 700, fontSize: "35px", marginTop: "0.5rem" }}>
                                        ₹{numberWithCommas(direct + milap + ketto + impactGuru)}
                                    </p>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4" >
                                <div className="dashboard_card">
                                    <p className="heading_text">
                                        Direct Transfer
                                    </p>
                                    <img src = {Direct} className="direct_transfer" alt="direct" />
                                    <p className="money_text">
                                        ₹{numberWithCommas(direct)}
                                    </p>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4" >
                                <div className="dashboard_card">
                                    <p className="heading_text">
                                        Milap
                                    </p>
                                    <img src = {Milap} className="direct_transfer" alt="Milap" />
                                    <p className="money_text">
                                        ₹{numberWithCommas(milap)}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className="row" style={{ textAlign: "center" }}>
                            <div className="col-sm-12 col-md-4" >
                                <div className="dashboard_card">
                                    <p className="heading_text">
                                        Ketto
                                    </p>
                                    <img src = {Ketto} className="direct_transfer" alt="Ketto" />
                                    <p className="money_text">
                                        ₹{numberWithCommas(ketto)}
                                    </p>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4" >
                                <div className="dashboard_card">
                                    <p className="heading_text">
                                        Impact Guru
                                    </p>
                                    <img src = {ImpactGuru} className="direct_transfer" alt="ImpactGuru" />
                                    <p className="money_text">
                                        ₹{numberWithCommas(impactGuru)}
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </>
            }
        </div>
    );
};

export default Home;